export const items = [
  {
    id: 0,
    title: "google pixel - black",
    price: 10,
    company: "google",
    description:
      "Shaman hexagon fam activated charcoal literally cardigan. Pitchfork YOLO man bun hella. Trust fund vexillologist squid put a bird on it man braid, selvage pug. Schlitz kombucha chillwave pug shabby chic cornhole. Try-hard four loko listicle yuccie kitsch small batch narwhal celiac selfies distillery cloud bread farm-to-table art party leggings glossier.",
    featured: true,
    image: "img/product-0.png",
    freeShipping: true
  },
  {
    id: 1,

    title: "samsung s7 - white",
    price: 20,
    company: "samsung",
    description:
      "Shaman hexagon fam activated charcoal literally cardigan. Pitchfork YOLO man bun hella. Trust fund vexillologist squid put a bird on it man braid, selvage pug. Schlitz kombucha chillwave pug shabby chic cornhole. Try-hard four loko listicle yuccie kitsch small batch narwhal celiac selfies distillery cloud bread farm-to-table art party leggings glossier.",
    featured: false,

    image: "img/product-1.png",
    freeShipping: false
  },
  {
    id: 2,

    title: "htc 10 - black",
    price: 30,
    company: "htc",
    description:
      "Shaman hexagon fam activated charcoal literally cardigan. Pitchfork YOLO man bun hella. Trust fund vexillologist squid put a bird on it man braid, selvage pug. Schlitz kombucha chillwave pug shabby chic cornhole. Try-hard four loko listicle yuccie kitsch small batch narwhal celiac selfies distillery cloud bread farm-to-table art party leggings glossier.",
    featured: false,

    image: "img/product-2.png",
    freeShipping: true
  },
  {
    id: 3,

    title: "htc 10 - white",
    price: 15,
    company: "htc",
    description:
      "Shaman hexagon fam activated charcoal literally cardigan. Pitchfork YOLO man bun hella. Trust fund vexillologist squid put a bird on it man braid, selvage pug. Schlitz kombucha chillwave pug shabby chic cornhole. Try-hard four loko listicle yuccie kitsch small batch narwhal celiac selfies distillery cloud bread farm-to-table art party leggings glossier.",
    featured: false,

    image: "img/product-3.png",
    freeShipping: false
  },
  {
    id: 4,

    title: "samsung s7 - black",
    price: 45,
    company: "google",
    description:
      "Shaman hexagon fam activated charcoal literally cardigan. Pitchfork YOLO man bun hella. Trust fund vexillologist squid put a bird on it man braid, selvage pug. Schlitz kombucha chillwave pug shabby chic cornhole. Try-hard four loko listicle yuccie kitsch small batch narwhal celiac selfies distillery cloud bread farm-to-table art party leggings glossier.",
    featured: false,

    image: "img/product-4.png",
    freeShipping: true
  },
  {
    id: 5,

    title: "samsung galaxy A8 - black",
    price: 55,
    company: "samsung",
    description:
      "Shaman hexagon fam activated charcoal literally cardigan. Pitchfork YOLO man bun hella. Trust fund vexillologist squid put a bird on it man braid, selvage pug. Schlitz kombucha chillwave pug shabby chic cornhole. Try-hard four loko listicle yuccie kitsch small batch narwhal celiac selfies distillery cloud bread farm-to-table art party leggings glossier.",
    featured: false,

    image: "img/product-5.png",
    freeShipping: false
  },

  {
    id: 6,

    title: "fuji X100s photo camera",
    price: 90,
    company: "fuji",
    description:
      "Shaman hexagon fam activated charcoal literally cardigan. Pitchfork YOLO man bun hella. Trust fund vexillologist squid put a bird on it man braid, selvage pug. Schlitz kombucha chillwave pug shabby chic cornhole. Try-hard four loko listicle yuccie kitsch small batch narwhal celiac selfies distillery cloud bread farm-to-table art party leggings glossier.",
    featured: true,

    image: "img/product-6.png",
    freeShipping: true
  },
  {
    id: 7,

    title: "canon Eos 30 photo camera",
    price: 120,
    company: "canon",
    description:
      "Shaman hexagon fam activated charcoal literally cardigan. Pitchfork YOLO man bun hella. Trust fund vexillologist squid put a bird on it man braid, selvage pug. Schlitz kombucha chillwave pug shabby chic cornhole. Try-hard four loko listicle yuccie kitsch small batch narwhal celiac selfies distillery cloud bread farm-to-table art party leggings glossier.",
    featured: false,

    image: "img/product-7.png",
    freeShipping: false
  },
  {
    id: 8,

    title: "nikon D 3100 photo camera",
    price: 55,
    company: "nikon",
    description:
      "Shaman hexagon fam activated charcoal literally cardigan. Pitchfork YOLO man bun hella. Trust fund vexillologist squid put a bird on it man braid, selvage pug. Schlitz kombucha chillwave pug shabby chic cornhole. Try-hard four loko listicle yuccie kitsch small batch narwhal celiac selfies distillery cloud bread farm-to-table art party leggings glossier.",
    featured: false,

    image: "img/product-8.png",
    freeShipping: true
  },
  {
    id: 9,

    title: "acer desktop computer",
    price: 35,
    company: "acer",
    description:
      "Shaman hexagon fam activated charcoal literally cardigan. Pitchfork YOLO man bun hella. Trust fund vexillologist squid put a bird on it man braid, selvage pug. Schlitz kombucha chillwave pug shabby chic cornhole. Try-hard four loko listicle yuccie kitsch small batch narwhal celiac selfies distillery cloud bread farm-to-table art party leggings glossier.",
    featured: true,

    image: "img/product-9.png",
    freeShipping: false
  },
  {
    id: 10,

    title: "hp desktop computer",
    price: 75,
    company: "hp",
    description:
      "Shaman hexagon fam activated charcoal literally cardigan. Pitchfork YOLO man bun hella. Trust fund vexillologist squid put a bird on it man braid, selvage pug. Schlitz kombucha chillwave pug shabby chic cornhole. Try-hard four loko listicle yuccie kitsch small batch narwhal celiac selfies distillery cloud bread farm-to-table art party leggings glossier.",
    featured: false,

    image: "img/product-10.png",
    freeShipping: true
  },
  {
    id: 11,

    title: "lenovo desktop computer",
    price: 110,
    company: "lenovo",
    description:
      "Shaman hexagon fam activated charcoal literally cardigan. Pitchfork YOLO man bun hella. Trust fund vexillologist squid put a bird on it man braid, selvage pug. Schlitz kombucha chillwave pug shabby chic cornhole. Try-hard four loko listicle yuccie kitsch small batch narwhal celiac selfies distillery cloud bread farm-to-table art party leggings glossier.",
    featured: false,
    image: "img/product-11.png",
    freeShipping: false
  },
  {
    id: 12,

    title: "dell desktop computer",
    price: 28,
    company: "dell",
    description:
      "Shaman hexagon fam activated charcoal literally cardigan. Pitchfork YOLO man bun hella. Trust fund vexillologist squid put a bird on it man braid, selvage pug. Schlitz kombucha chillwave pug shabby chic cornhole. Try-hard four loko listicle yuccie kitsch small batch narwhal celiac selfies distillery cloud bread farm-to-table art party leggings glossier.",
    featured: false,
    image: "img/product-12.png",
    freeShipping: true
  }
];
